@for (label of colorLabels; track label) { @if (label.active) {
<app-button-menu-item
  name="color-label"
  [location]="location"
  [analyticsExtra]="{ color: label.color, colorLabelName: label.name | translateLabel }"
  (click)="updateColorLabel.emit(label.color)"
  icon="color-label-filled"
  [iconColor]="label.color"
  [weight]="label.color === currentColorLabel ? 'bold' : ''"
  [fullWidth]="true"
  [shortcut]="label.color | colorLabelShortcut"
  [attr.data-test-id]="'color_label_' + label.color"
>
  <span class="{{ label.color === currentColorLabel ? 'text-color-' + label.color : '' }}">{{
    label.name | translateLabel
  }}</span>
</app-button-menu-item>
} }
<app-button-menu-item
  name="color-label"
  [location]="location"
  [analyticsExtra]="{ color: null }"
  (click)="updateColorLabel.emit(null)"
  icon="color-label-dotted"
  [iconColor]="'grey-80'"
  [weight]="null === currentColorLabel ? 'bold' : ''"
  shortcut="N"
  [fullWidth]="true"
>
  <span class="{{ null === currentColorLabel ? 'text-color-grey-80' : '' }}">{{ 'not-labeled' | translate }}</span>
</app-button-menu-item>
